// extracted by mini-css-extract-plugin
export default {"divAdmin":"excel_divAdmin__WGFBl"};